<template>
    <div class="paper-admin">
      <div class="paper-admin-header">
        <div class="header-select">
          试卷等级
          <el-select v-model="paperGradeValue" clearable style="width: 420px;margin-left: 12px" placeholder="选择试卷等级" @change="selectPaper">
            <el-option
                v-for="item in paperGradeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="addPaperTemplate"><i class="el-icon-plus" style="font-size: 14px;margin-right: 4px"></i>创建试卷模板</el-button>
      </div>
      <el-table class="customTable" :data="paperList" style="width: 100%; margin-top: 20px; flex: 1;" height="1%" size="medium"
                :header-cell-style="{fontWeight: 'normal', height: '60px', color: '#666666', background: '#F6F6F6',fontSize: '16px'}"
                :cell-style="{fontSize: '16px',color: '#333333',height: '70px'}">
        <el-table-column prop="name" align="left" label="试卷名称"></el-table-column>
        <el-table-column prop="level" align="center" label="试卷等级"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-link type="success" @click="editPaper(scope.row.id)" :underline="false">编辑</el-link>
            <el-link type="danger" @click="deletePaper(scope.row.id)" :underline="false">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
<!--      <pagination :total="paperPages.total" @current-change="paperCurrentChange" />-->
      <el-pagination class="pager-center" style="margin: 20px 0 30px;text-align: center"
                     :current-page="paperPages.currentPageNum"
                     :page-size="paperPages.eachPageNum"
                     :total="paperPages.total"
                     layout="prev, pager, next, jumper"
                     @current-change="paperCurrentChange">
      </el-pagination>
    </div>
</template>

<script>
import pagination from '@/components/pagination.vue'
import {paperListPaper, paperDelPaper} from '@/utils/apis'
export default {
  name: "Index",
  components:{
    pagination
  },
  data(){
    return {
      paperGradeValue:'',
      paperGradeList:[
        {
          label:'四级电子商务员',
          value:1
        },
        {
          label:'三级助理电子商务师',
          value:2
        },
      ],
      paperList:[],
      paperPages:{
        currentPageNum: 1,
        eachPageNum: 10,
        total: 0,
      },
    }
  },
  mounted() {
    this.getPaperList()
  },
  methods:{
    getPaperList(){
      let params = {
        type:'page',
        page:this.paperPages.currentPageNum,
        limit:this.paperPages.eachPageNum
      }
      if(this.paperGradeValue){
        params.level = this.paperGradeValue;
      }
      paperListPaper(params).then((res)=>{
        this.paperList = res.data.data;
        this.paperPages.total = res.data.total;
      }).catch((err)=>{
        console.log('err', err)
      })
    },
    editPaper(id){
      this.$router.push({
        path:'/paper/addPaperTemplate',
        query:{
          id:id
        }
      })
    },
    deletePaper(id){
      this.$confirm(`此操作将永久删除该试卷，是否继续`, '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass:'green-message-box',
        type:'warning'
      }).then(()=>{
        let params = {
          id:id
        }
        paperDelPaper(params).then((res)=>{
          this.$message({
            message:res.msg,
            type:'success',
            duration:1000,
            onClose:()=>{
              this.getPaperList();
            }
          })
        }).catch((err)=>{
          console.log('err', err)
        })
      }).catch(()=>{
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    selectPaper(){
      this.getPaperList()
    },
    addPaperTemplate(){
      this.$router.push('/paper/addPaperTemplate')
    },
    paperCurrentChange(val){
      this.paperPages.currentPageNum = val;
      this.getPaperList();
    }
  }
}
</script>

<style scoped lang="scss">
.paper-admin{
  padding: 0px 20px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  .paper-admin-header{
    display: flex;
    justify-content: space-between;
    .header-select{
      display: flex;
      align-items: center;
    }
  }
}
</style>